import { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useOrderApi, { Order } from "../../api/OrderApi";

interface Props {
  kitId: number;
}

const KitActiveOrders = (props: Props) => {
  const orderApi = useOrderApi();
  const [activeOrders, setActiveOrders] = useState<Order[]>()

  useEffect(() => {
    orderApi
      .fetchKitActiveOrders(props.kitId)
      .then(setActiveOrders);
  }, [props.kitId]);

  return <>
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        Aktywne zamówienia
      </AccordionSummary>
      <AccordionDetails>
      { activeOrders === undefined
        ? <div>...</div>
        : activeOrders.length === 0
          ? <div>Komplet nie jest wykorzystany w żadnym aktywnym zamówieniu</div>
          : <ul> { activeOrders.map(order => (<li>Zamówienie: {order.number}</li>)) }</ul>
      }
      </AccordionDetails>
    </Accordion>
    </>;
}

export default KitActiveOrders;